export default __webpack_public_path__ + "static/media/languages.7220721b.png";